// extracted by mini-css-extract-plugin
export default {"cls1":"YgtD35xgF1lAwFk3F1UN","cls2":"oZnKwcz_xipTTPzb_1QY YgtD35xgF1lAwFk3F1UN"};